var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"manager-footer center"},[_c('small',[_vm._v("Copyright © 2019 Golden Bough Theatre. All rights reserved. Design by "),_c('a',{attrs:{"href":"https://www.twodot.com.tw","target":"_blank"}},[_c('u',[_vm._v("TwoDot 兩打半互動設計")])])])])
}]

export { render, staticRenderFns }